<i18n>
{
  "en": {
    "tsumHighPriceTip": "As long as you spend US$21.99 per month to subscribe to our service, you can get an average of 30 million gold coins (worth 37,500 rubies, approximately equal to US$1,160).",
    "useXRobotmonForSpeed": "Increase your earning speed by at least 55x with XRobotmon"
  },
  "zhHant": {
    "tsumHighPriceTip": "只要每月花 699 台幣訂閱我們的服務平均可獲得三千萬金幣（價值 37,500 顆紅寶石，約等於 37,500 台幣）",
    "useXRobotmonForSpeed": "使用 XRobotmon 至少提升您 55x 賺錢速度"
  },
  "ja": {
    "tsumHighPriceTip": "30日間3,580円のプランで、平均3,000万コインを獲得できます（ルビー37,500個分、約173,500円相当）。",
    "useXRobotmonForSpeed": "Xロボットモンなら、報酬を集めるスピードが手動プレイの55倍以上になります。"
  },
  "ko": {
    "tsumHighPriceTip": "매월 $21.99를 지출하여 서비스에 가입하면 평균 3천만 개의 금화(루비 37,500개, 약 US$1,160에 해당)를 얻을 수 있습니다.",
    "useXRobotmonForSpeed": "XRobotmon을 사용하여 속도를 최소 55배로 증가시키세요"
  }
}
</i18n>
<template>
  <v-alert :value="isShow" color="warning" outline>
    <p>
      {{ $t('useXRobotmonForSpeed') }}
    </p>
    <p v-if="supportGame === 'tsum'">
      {{ $t('tsumHighPriceTip') }}
    </p>
  </v-alert>
</template>
<script>
export default {
  name: 'HighPriceHint',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    supportGame: {
      type: String,
      default: 'tsum',
    }
  }
}
</script>
